// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__FPsJK","topBottomGutter":"Layout_topBottomGutter__3ilAw"};